module.exports = __webpack_public_path__ + "img/icos5.7f576851.svg";